import * as React from "react";
import { CSVLink } from "react-csv";
import { Icon, Popup } from "semantic-ui-react";

export type ExcelExportProps = {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  rows: any[];
  columns: State.Column[];
  filename: string;
  useIcon?: boolean;
};

/** ExcelExport component */
const ExcelExport: React.FC<ExcelExportProps> = ({ rows, columns, filename, useIcon }) => {
  // Non-visible columns are excluded and cell values are got using accessor functions
  const tableData = rows.map(row => {
    let excelRow = {};
    columns.forEach(column => {
      const getValue = column.exportAccessor || column.ownAccessor;
      excelRow = {
        ...excelRow,
        [column.name]: getValue(row) !== null ? getValue(row) : null
      };
    });
    return excelRow;
  });
  const visibleElement = useIcon ? (
    <Icon className="color-orange" link={true} size="large" name="file excel" />
  ) : (
    <span>Export</span>
  );

  let headers;

  if (filename === "Elevator Parameters") {
    headers = [
      {
        label: "ID",
        key: "Code"
      },
      {
        label: "Parameter Name",
        key: "English name"
      },
      {
        label: "Item Count",
        key: "Item Count"
      },
      {
        label: "Default Value",
        key: "swDefaultValue"
      },
      {
        label: "Min Value",
        key: "Min Value"
      },
      {
        label: "Max Value",
        key: "Max Value"
      },

      {
        label: "Description",
        key: "Comment"
      },
      {
        label: "Category / SubCategory",
        key: "Category / SubCategory"
      },
      {
        label: "Requires reset",
        key: "Requires reset"
      },
      {
        label: "Requires setup",
        key: "Requires setup"
      }
    ];
  } else {
    headers = columns.map(column => ({
      label: (column as any).Header,
      key: (column as any).Header
    }));
  }

  return (
    <>
      {tableData.length > 0 && (
        <CSVLink
          data={tableData}
          headers={headers}
          filename={`${filename}.csv`}
        >
          <Popup trigger={visibleElement} content={"Export to Excel"} />
        </CSVLink>
      )}
    </>
  );
};

export default ExcelExport;

